const pushDataLayer = (dataObject) => {
  if (window.dataLayer) {
    window.dataLayer.push(dataObject);
  }
};
export default pushDataLayer;
